import { AreaCodeInfo, AreaEnum } from "../types/user";

// 区号
export const AREA_CODES: AreaCodeInfo = [
	{
		area: '中国大陆',
		tip: '中国大陆区号',
		reg: /^\d+$/,
		code: AreaEnum.CN
	},
	{
		area: 'Singapore',
		tip: 'Singapore area code',
		reg: /^\d+$/,
		code: AreaEnum.SG
	},
	{
		area: '中國香港',
		tip: '中國香港區號',
		reg: /^\d+$/,
		code: AreaEnum.HK,
	},
	{
		area: '中國台湾',
		tip: '中國台湾區號',
		reg: /^\d+$/,
		code: AreaEnum.TW,
	},
	{
		area: 'Việt Nam',
		tip: 'Mã vùng Việt Nam',
		reg: /^\d+$/,
		code: AreaEnum.VN,
	},
	{
		area: 'Indonesia',
		tip: 'Kode daerah Indonesia',
		reg: /^\d+$/,
		code: AreaEnum.IN,
	},
	{
		area: 'Malaysia',
		tip: 'Kod kawasan Malaysia',
		reg: /^\d+$/,
		code: AreaEnum.MA,
	},
  {
		area: 'Bahrain(البحرين)',
		reg: /^\d+$/,
		tip: 'The Kingdom of Bahrain',
		code: AreaEnum.BHR,
	},
];

// 登录需要跳过的字符
export const ADMIN_ARRAY:Array<string> = [
	'Administrator'
]

export const avatarColors:Array<string> = [
	'#DC143C',
	'#FF69B4',
	'#9400D3',
	'#8B4513',
	'#D2691E',
	'#FA8072',
	'#2F4F4F',
	'#8B008B',
	'#90EE90',
	'#66CDAA',
	'#48D1CC',
	'#FF6347'
]

export const PAGE_SIZE = 50;